import React, { Fragment } from "react";
import Favicon from "../images/favicon.png";

export default class Logo extends React.Component<{
  style: Record<string, unknown>;
}> {
  render(): JSX.Element {
    const { style } = this.props;
    return (
      <Fragment>
        <img src={Favicon} alt="petra-favicon" style={style} />
      </Fragment>
    );
  }
}
